import {CompetitionEvent} from './CompetitionEvent';

export class CompetitionUpdated extends CompetitionEvent {}
